import { render, staticRenderFns } from "./AdminTwoFactor.vue?vue&type=template&id=0b1cfe9a&"
import script from "./AdminTwoFactor.vue?vue&type=script&lang=js&"
export * from "./AdminTwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./AdminTwoFactor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports